import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../../hooks/AuthContext';
import { setCalendarWorkspace } from '../services';
import { setZoomWorkspace } from '../../../services/zoomAccountsService';

const CalendarLayout = () => {
    const { user } = useAuth();

    // Initialize workspace for all calendar pages.
    // El workspace de Zoom también: sin él, las consultas a `zoom_accounts` salen
    // sin filtro y traerían cuentas de otros workspaces (distribución Zoom incluida).
    useEffect(() => {
        if (user?.uid) {
            setCalendarWorkspace(user.uid);
            setZoomWorkspace(user.uid);
        }
    }, [user?.uid]);

    // El menú del módulo (Calendario, Planificación, Instructores…) y la leyenda de
    // colores viven ahora en el sidebar global (components/layout/AppSidebar.jsx).
    // CalendarSidebar.jsx se conserva sin usar por si hay que volver atrás.
    return (
        <main className="h-full overflow-y-auto flex flex-col bg-white lg:bg-gray-50">
            <div className="flex-1 h-full">
                <Outlet />
            </div>
        </main>
    );
};

export default CalendarLayout;
